<div class="flex flex-col gap-6">
  <div class="ec-category-header">
    {{ 'dashboard.overview.services.title' | translate }}
  </div>

  <div class="grid grid-cols-2 lg:grid-cols-3 gap-4">
    <app-status-card [config]="queryDisconnect"></app-status-card>
    <app-status-card [config]="queryCloseDown"></app-status-card>
    <app-status-card [config]="queryDeliveryDisconnect"></app-status-card>
    <app-status-card [config]="queryReopen"></app-status-card>
    <app-status-card [config]="serviceRequestMeterControl"></app-status-card>
  </div>
</div>
